module.exports = __webpack_public_path__ + "static/media/lira-sign.22651385.svg";